module.exports = __webpack_public_path__ + "0c0fb04f5c8e3df7cce9dcbc4c9d2e8b.svg";